import { Router } from '@lightningjs/sdk';
// Not Found
import NotFound from './NotFound/NotFound';
// Profile
import Profile from './Profile/Profile';
import profileProvider from '../pages/Profile/providers/profile';
// Home
import Home from './Home/Home';
import homeProvider from '../pages/Home/providers/home';
// New
import New from './New/New';
import newProvider from '../pages/New/providers/new';
// My List
import MyList from './MyList/MyList';
import myList from './MyList/providers/myList';
// Settings
import Settings from './Settings/Settings';
// Sign out
import SignOut from './Settings/SignOut/SignOut';
// Exit
import Exit from './Settings/Exit/Exit';
// AudioSubtitles
import AudioSubtitles from './Settings/AudioSubtitles/AudioSubtitles';
import audioSubtitles from './Settings/AudioSubtitles/providers/audioSubtitles';
//My Account
import MyAccount from './Settings/MyAccount/MyAccount';
import myAccount from './Settings/MyAccount/providers/myAccount';
// Search
import Search from './Search/Search';
import search from './Search/providers/search';
// Single Movie
import Movie from './SingleMovie/Movie';
import singleMovie from './SingleMovie/providers/movie';
// Single Series
import Series from './SingleSeries/Series';
import singleSeries from './SingleSeries/providers/series';
// Support
import Support from './Settings/Support/Support';
// Edit Profiles
import EditProfiles from './Profile/EditProfiles/EditProfiles';
import editProfileProvider from '../pages/Profile/EditProfiles/providers/profile';
// Choose Avatar
import Avatars from './Profile/Avatar/Avatars';
import profileAvatar from './Profile/Avatar/providers/avatar';
// Filters
import Filters from './Settings/Filters/Filters';
import filter from './Settings/Filters/providers/filter';
// Player
import Player from './Player/Player';
import player from './Player/provider/player';
// Edit Single Profile
import editSingleProfileProvider from './Profile/EditSingleProfile/providers/profile';
import EditSingleProfile from './Profile/EditSingleProfile/EditSingleProfile';
// Audio & Subtitles
import AudioSubtitlesMovie from './SingleMovie/Audio&Subtitles/AudioSubtitles';
import movieProvider from './SingleMovie/Audio&Subtitles/providers/movie';
// Audio & Subtitles Series
import AudioSubtitlesSeries from './SingleSeries/Audio&Subtitles/AudioSubtitles';
import seriesProvider from './SingleSeries/Audio&Subtitles/providers/series';
// Login
import Login from './Login/Login';
import LoginOnline from './Login/LoginOnline/LoginOnline';
import loginOnline from './Login/LoginOnline/providers/loginOnline';
import EmailLogin from './Login/EmailLogin/EmailLogin';
import PasswordLogin from './Login/PasswordLogin/PasswordLogin';
import loginProvider from './Login/providers/login';
// Episodes
import Episodes from './SingleSeries/Episodes/Episodes';
import episodesProvider from './SingleSeries/Episodes/providers/episodes';
//Create Profile
import CreateProfile from './Profile/CreateProfile/CreateProfile';
import profile from './Profile/CreateProfile/providers/profile';
// Categories
import categories from './Categories/providers/categories';
import Categories from './Categories/components/Categories';
import LockedDialog from './SingleMovie/components/LockedDialog';

const token = localStorage.getItem('userToken');
export default {
  // Starting page
  root: token ? 'profile' : 'login',
  // Load on boot configuration
  // boot: api.loadConfig,
  routes: [
    {
      path: 'player',
      on: player,
      component: Player,
      options: {
        preventStorage: true,
        reuseInstance: false,
      },
    },
    {
      path: 'player/:id',
      on: player,
      component: Player,
      options: {
        preventStorage: true,
        reuseInstance: false,
      },
    },
    {
      path: 'profile/create-profile',
      component: CreateProfile,
      on: profile,
      cache: 60 * 10,
    },
    {
      path: 'profile',
      component: Profile,
      on: profileProvider,
      cache: 0,
    },
    {
      path: 'login',
      component: Login,
      on: loginProvider,
    },
    {
      path: 'login-online',
      component: LoginOnline,
      on: loginOnline,
    },
    {
      path: 'login-with-email',
      component: EmailLogin,
      on: loginProvider,
    },
    {
      path: 'login-with-password',
      component: PasswordLogin,
      on: loginProvider,
    },
    {
      path: 'profile/edit-profiles',
      component: EditProfiles,
      on: editProfileProvider,
    },
    {
      path: 'profile/edit-profile/:profileId',
      component: EditSingleProfile,
      on: editSingleProfileProvider,
      options: {
        reuseInstance: false,
      },
      cache: 60 * 60,
    },
    {
      path: 'profile/choose-avatar',
      component: Avatars,
      on: profileAvatar,
    },
    {
      path: 'search',
      component: Search,
      on: search,
      widgets: ['sidebar'],
    },
    {
      path: 'browse',
      component: Home,
      on: homeProvider,
      widgets: ['sidebar'],
      cache: 0,
    },
    {
      path: 'categories/:id',
      on: categories,
      component: Categories,
      widgets: ['sidebar'],
      cache: 0,
    },
    {
      path: 'movie/:movieId',
      on: singleMovie,
      component: Movie,
      cache: 0,
    },
    {
      path: 'movie/:movieId/audio-subtitles',
      component: AudioSubtitlesMovie,
      on: movieProvider,
    },
    {
      path: 'series/:serieId/audio-subtitles',
      component: AudioSubtitlesSeries,
      on: seriesProvider,
    },
    {
      path: 'series/:seriesId',
      on: singleSeries,
      component: Series,
      cache: 0,
    },
    {
      path: 'series/:seriesId/episodes',
      on: episodesProvider,
      component: Episodes,
      cache: 0,
    },
    {
      path: 'new',
      component: New,
      on: newProvider,
      widgets: ['sidebar'],
      cache: 0,
    },
    {
      path: 'my-list',
      component: MyList,
      on: myList,
      widgets: ['sidebar'],
    },
    {
      path: 'settings',
      component: Settings,
      widgets: ['sidebar'],
    },
    {
      path: 'settings/my-account',
      on: myAccount,
      component: MyAccount,
    },
    {
      path: 'settings/sign-out',
      component: SignOut,
    },
    {
      path: 'settings/exit',
      component: Exit,
    },
    {
      path: 'settings/audio-subtitles',
      component: AudioSubtitles,
      on: audioSubtitles,
      cache: 0,
    },
    {
      path: 'settings/support',
      component: Support,
    },
    {
      path: 'settings/filters',
      component: Filters,
      on: filter,
    },
    {
      path: 'locked',
      component: LockedDialog,
    },
    {
      path: '*',
      component: NotFound,
      beforeNavigate() {
        Router.navigate('browse', false);
      },
    },
  ],
};
